// Define SwiperSlider regardless of its previous registration state
class SwiperSlider extends HTMLElement {
    constructor() {
        super();
        this.slideContainer = this.querySelector("[data-swiper]:not([data-swiper-thumbs])");
        this.slides = this.querySelectorAll("[data-swiper-slide]");
        this.sliderOptions = this.applyDefaultOptions(this.getSliderOptions());
        this.activeIndex = 0;
        this.initialized = false;

        if (this.dataset.swiperThumbs) {
            this.thumbnails = this.querySelector('[data-swiper-thumbs]');
        }
        if (this.dataset.customEvent) {
            this.attachCustomListeners(this.dataset.customEvent);
        }

        // Prevent auto-initialization if disable-auto-init is present
        if (!this.hasAttribute('disable-auto-init')) {
            this.setupEventListeners();
        }
    }

    setupEventListeners() {
        if (this.slideContainer && this.slides.length > 0) {
            document.addEventListener("DOMContentLoaded", this.initializeSwiper.bind(this));
            document.addEventListener("shopify:section:load", this.initializeSwiper.bind(this));
            window.addEventListener("resize", this.handleResize.bind(this));
        } else {
            console.warn("SwiperSlider - Slider or Slides Not Found");
        }
    }

    attachCustomListeners(customEvent) {
        switch (customEvent) {
            case "swiper_event":
                document.addEventListener("swiper_event", this.updateSlides.bind(this));
                break;
        }
    }

    updateSlides(event) { }

    goToSlide(targetSlideDataset) {
        const targetSlide = this.querySelector(`[data-slide-id=${targetSlideDataset}]`);
        if (targetSlide !== null) {
            const targetSlideIndex = targetSlide.dataset.slideIndex;
            this.slider.slideTo(Number(targetSlideIndex), 500, false);
        }
    }

    applyDefaultOptions(options) {
        if (options.loop === undefined) {
            options.loop = true;
        }
        // options.speed = 400;
        return options;
    }

    handleAutoplayOnMediaMatch() {
        const mediaQuery = `(max-width: ${this.getAttribute('autoplay-disable-media')})`;
        const mediaQueryList = window.matchMedia(mediaQuery);

        if (mediaQueryList.matches) {
            this.slider.autoplay.stop();
            this.slider.params.autoplay.disableOnInteraction = true;
            this.slider.params.freeMode.enabled = false;
            this.slider.params.speed = 400;
        }
    }

    handleAutoplayOnHover() {
        if (this.hasAttribute('swiper-mouse-sensetive')) {
            this.addEventListener('mouseenter', () => {
                this.slider.autoplay.stop();
            });
            this.addEventListener('mouseleave', () => {
                this.slider.autoplay.start();
            });
        }
    }

    getSliderOptions() {
        try {
            return JSON.parse(this.dataset.options);
        } catch (err) {
            console.log(err);
            return {};
        }
    }

    initializeSwiper() {
        if (window.Swiper && !this.initialized) {
            this.initialized = true;
            if (this.thumbnails) {
                this.setThumbnails();
            }

            this.slider = new Swiper(this.slideContainer, this.sliderOptions);
            // this.setAttribute('swiper-initialized', '');

            this.setAttribute('swiper-initialized', '');
            this.initializeSliderEventListeners();
        } else if (!window.Swiper) {
            console.warn("SwiperSlider - Swiper.js not found");
        }
    }

    handleResize(e) {
        if (this.slider) {
            setTimeout(() => {
                this.slider.updateSize();
            }, 300);
        }
    }

    setThumbnails() {
        const thumbsSlideContainer = this.thumbnails;
        const thumbOptions = JSON.parse(this.thumbnails.dataset.swiperOptions);
        const thumbnailsSlider = new Swiper(thumbsSlideContainer, thumbOptions);
        this.sliderOptions.thumbs = { swiper: thumbnailsSlider };
    }

    initializeSliderEventListeners() {
        this.handleAutoplayOnHover();
        this.handleAutoplayOnMediaMatch();
    }
}

customElements.define("swiper-slider", SwiperSlider);


// Register the SwiperSlider component if not already defined
if (!customElements.get("responsive-swiper-slider")) {
    class ResponsiveSwiperSlider extends SwiperSlider {
        constructor() {
            super();
            this.maxWidth = this.dataset.maxWidth || '768px'; // Default max-width to 768px if not provided
            this.sliderInitialized = false;

            // Watch for resize to initialize or destroy the slider accordingly
            this.watchForResize();
            this.initOrDestroySlider(); // Attempt to initialize at the start
        }

        initOrDestroySlider() {
            const mediaQuery = window.matchMedia(`(max-width: ${this.maxWidth})`);
            if (mediaQuery.matches && !this.sliderInitialized) {
                this.initializeSwiper(); // Initialize from parent class
                this.sliderInitialized = true;
                this.setAttribute('initialized', '');
            } else if (!mediaQuery.matches && this.sliderInitialized) {
                this.destroySwiper(); // New method to destroy the swiper
                this.removeAttribute('initialized');
            }
        }

        destroySwiper() {
            if (this.slider && this.sliderInitialized) {
                this.slider.destroy(true, true);
                this.sliderInitialized = false;
            }
        }


        initializeSwiper() {
            const mediaQuery = window.matchMedia(`(max-width: ${this.maxWidth})`);
            if (window.Swiper && mediaQuery.matches && !this.sliderInitialized) {
                this.initialized = true;
                if (this.thumbnails) {
                    this.setThumbnails();
                }

                this.slider = new Swiper(this.slideContainer, this.sliderOptions);
                // this.setAttribute('swiper-initialized', '');

                this.initializeSliderEventListeners();
            } else if (!window.Swiper) {
                console.warn("SwiperSlider - Swiper.js not found");
            }
        }

        watchForResize() {
            // Call initOrDestroySlider on resize
            window.addEventListener('resize', this.initOrDestroySlider.bind(this));
        }

        setThumbnails() {
            const thumbsSlideContainer = this.thumbnails;
            const thumbOptions = JSON.parse(this.thumbnails.dataset.swiperOptions);
            const thumbnailsSlider = new Swiper(thumbsSlideContainer, thumbOptions);
            this.sliderOptions.thumbs = { swiper: thumbnailsSlider };
        }

        // Override handleResize but keep it as no-op
        handleResize() {
            // No-op: Ignoring resize behavior for ResponsiveSwiperSlider
        }
    }

    customElements.define("responsive-swiper-slider", ResponsiveSwiperSlider);
}